import React from "react";
import { defaultLanguage } from "../types";

export default class LocaleTextarea extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            'hasError': false,
            'errorText': ''
        };
    }

    /**
     * React lifecycle method; used to monitor change in language
     * @param {any} nextProps 
     * @param {any} nextState
     * @returns {Boolean} 
     */
    shouldComponentUpdate(nextProps){
        // if language changed, update the textarea with new default value
        if(nextProps.defaultValue !==  this.textAreaRef.value){
            this.textAreaRef.value = nextProps.defaultValue;
        }
        
        return true;
    }

    handleTextareaBlur(event){
        if(this.props.valKey === 'prompt'){
            const {type, idx, isEnUS, ttsVoice} = this.props;
            const value = this.textAreaRef.value || "";
            const lang = (this.props.isEnUS) ? defaultLanguage : this.props.language;
            const parentComponentID = this.props.parentComponentID; 
            const channelLayer = this.props.channelLayer;
            //validating for non-empty
            if (isEnUS && this.props.context?.validateInput) {
                if (this.props.context.validateInput?.(event)) {
                    this.setState({ errorText: '', hasError: false });
                } else {
                    this.setState({ errorText: window.l.settings.filler_prompts.no_empty_message, hasError: true });
                }
            } else {
                this.setState({ errorText: '', hasError: false });
            }
            
            this.props.context.setConfig(this.props.valKey, { value, type, idx, isEnUS, lang, parentComponentID, channelLayer, ttsVoice });
        }
    }
    
    render(){
        const {hasError, errorText} = this.state;
        const errorClass = (hasError) ? 'error' : '';

        return (
            <div>
                <div className="form-component textarea">
                    <textarea
                        ref={(textarea) => { this.textAreaRef = textarea; }}
                        style={{'height': 'auto'}}
                        className={"form-component " + errorClass}
                        onBlur={(event) => this.handleTextareaBlur(event)}
                        rows={this.props.rowsVal}
                        defaultValue={this.props.defaultValue || ""}
                       />
                      
                    <div className={"form-error-tip " + errorClass} style={{'display': (hasError)? 'block': 'none'}}>{errorText}</div>
                </div>
                
            </div>
        );
        

    }
}
